import { render, staticRenderFns } from "./RfIdScanInfo.vue?vue&type=template&id=96d8f7d2&scoped=true"
import script from "./RfIdScanInfo.vue?vue&type=script&lang=js"
export * from "./RfIdScanInfo.vue?vue&type=script&lang=js"
import style0 from "./RfIdScanInfo.vue?vue&type=style&index=0&id=96d8f7d2&prod&lang=less"
import style1 from "./RfIdScanInfo.vue?vue&type=style&index=1&id=96d8f7d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8f7d2",
  null
  
)

export default component.exports